module.exports = __webpack_public_path__ + "static/media/banner.0c64edd1.jpg";